import React from "react";
import DatePicker from './DatePicker'
import FixButton from './Button'
import Cookies from 'universal-cookie';
import moment from 'moment';
import getLezioni from "../services/getLezioni";
import getInsegnanti from "../services/getInsegnanti";
import generateExcel from "../services/generateExcel";
import Constants from "../utils/consts";

export default class SelectExcelDateWidget extends React.Component {

    constructor (props){
        super(props);

        this.dateRef = React.createRef();

    }

    async componentDidMount(){
        const cookies = new Cookies();
        const username = cookies.get('username', { path: '/' });
        const token = cookies.get('token', { path: '/' });
        this.lezioni = await getLezioni(username, token);
        this.insegnanti = await getInsegnanti(username, token);
        this.setState({
            visible: this.props.show,
        });

    }

    render (){

        if (!this.state) return <div />;
        let st = Object.assign({display: this.state.visible ? 'block' : 'none'}, mainClass);

        return ( 
            <>
                <div key={Math.random()} style={st} >
                    <div style={closeIcon} onClick={() => {
                        this.setState({visible: false});
                        this.props.onCancel();
                    }}>X</div>
                    <div style={{marginTop: '10px'}}>
                        <div className="windowTitle">
                            Seleziona la data
                        </div>
                        <DatePicker ref={this.dateRef} name="Il: " />
                        <FixButton title={'OK'} callback={this.okClicked.bind(this)} />
                    </div>
                </div>
            </>
        )
    }

    checkInvestor(investors, id){
        investors.map(v => {
            if (v.id == id) return true;
        });
        return false;
    }

    async okClicked(){

        const cookies = new Cookies();
        const username = cookies.get('username', { path: '/' });
        const token = cookies.get('token', { path: '/' });

        const date = this.dateRef.current.getDate();

        let il = moment(date).format('yyyy-MM-DD');

        if (il == "Invalid date") {
            alert("Scegli una data valida.")
            return
        }

        let lezioni = this.lezioni.filter((lezione) => {
            let dataLezione = moment(lezione.data, "yyyy-MM-DD HH:mm:ss").format("yyyy-MM-DD");
            
            return dataLezione === il;
        });
        if (lezioni.length === 0) {
            alert('Nessuna lezione trovata')
            return
        }

        let datiInsegnanti = [];
        lezioni.forEach(lezione => {
            let insegnantiLezione = [];
            insegnantiLezione.push(lezione.id_insegnante)
            let ins = lezione.altri_insegnanti.split(";")
            ins.forEach(el => {
                if (el) {
                    insegnantiLezione.push(el)
                }
            })
            let insegnanti = this.insegnanti.filter((insegnante) => {
                return insegnante.regime === 'FAT_1' && insegnantiLezione.indexOf(insegnante.id) !== -1;
            })
            insegnanti.forEach(e=> {
                datiInsegnanti.push(e)
            })
        })

        datiInsegnanti = Array.from(new Set(datiInsegnanti))

        var jsonData = [];
        datiInsegnanti.forEach(insegnante => {
            jsonData.push([insegnante.nome, insegnante.cognome, insegnante.mail]);
        });

        console.log(jsonData);
        
        var jsonTabs = [];
        jsonTabs.push({
            name: 'Presenze_' + il.replace('-','_'),
            data: jsonData
        });

        var json = {
            tabs : jsonTabs
        };

        await generateExcel(username, token, JSON.stringify(json), 'Presenze_' + il.replace('-','_'));
        window.open('https://' + Constants.mainUrl + 'pdf/' + 'Presenze_' + il.replace('-','_') + '.xlsx', '_blank');

        this.props.onOkClicked(il);
    }
}


const menu = {
    position: 'relative',
    top: '10px',
    display: 'flex',
};

const menuVoice = {
    width: '50%',
    textAlign: 'center',
    border: '1px solid black',
    cursor: 'pointer'
}

const title = {
    top: '10xp',
    width: '100%',
    height: '40px',
    lineHeight: '40px',
    textAlign: 'center',
};

const closeIcon = {
    position: 'absolute', 
    cursor: 'pointer',
    right: 0, 
    top: 0, 
    padding: 10
}

const mainClass = {
    position: 'fixed',
    left: '35%',
    top: '10%',
    background: '#ffffff',
    border: '1px solid black',
    padding: '20px',
    zIndex: 999
}

const name = {
    
}

const inputText = {
    width: '300px',
    padding: '10px'
}


const inputTextDisabled = {
    background: '#eeeeee',
    width: '300px',
    padding: '10px'
}